import { useCallback } from 'react';

export type AdRewardButtonState = 'idle' | 'cooldown' | 'pending' | 'loading' | 'claimed';

export function useAdReward() {
	const handlePress = useCallback(() => {
		// no-op on web
	}, []);

	return {
		buttonState: 'idle' as AdRewardButtonState,
		chips: 0,
		cooldownLabel: '',
		handlePress,
		justClaimed: false,
		adReady: false,
	};
}
